export const MATERIAL_DATEPICKER_FORMATS = {
  parse: {
    dateInput: 'YYYY/MM/DD',
  },
  display: {
    dateInput: 'YYYY/MM/DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MMM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const DATE_TIME_FORMAT = 'yyyy-MM-dd · HH:mm';

// Saudi Arabia has no daylight saving, so a fixed offset is enough.
export const SAUDI_TIMEZONE = '+0300';
